import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AiFillCopy, AiFillDelete, AiFillTool } from 'react-icons/ai';
import { toast } from 'react-toastify';
import { UserContext } from '../../context/UserContext';
import AttToken from '../../helpers/attToken';
import { UnidadeType } from '../../service/Places';
import { AuthBodyType } from '../../service/types';
import Unity from '../../service/Unity';
import { AxiosError } from 'axios';
import RemoveModal from './Modals/RemoveModal';
import EditModal from './Modals/EditModal';
import QrCodeModal from './Modals/QrCodeModal';
import { trackEventMatomo } from '../../helpers/matomo';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import QueryFn from '../../helpers/QueryFn';

const UnityService = new Unity();
const queryFn = new QueryFn();

export default function UnityComponent({
  unity,
  getPlaces,
  set,
  unidadesList,
}
  : {
    unity: UnidadeType,
    getPlaces: Function,
    selected: string[],
    set: string,
    unidadesList: UnidadeType[],
  }) {
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openRemove, setOpenRemove] = useState(false);
  const { hierarchyLabel, customerId } = useContext(UserContext);
  const [isDisabled, setIsDisabled] = useState(false);
  const { t } = useTranslation('translation');

  const { mutate } = queryFn.useMutate('removeUnity',
    async () => {
      toast.warn(`${t('notifications.deleteNotifWait')}`);
      try {
        const data = await AttToken();
        await UnityService.deleteUnity(data as AuthBodyType, unity.id, set);
        toast.success(`${hierarchyLabel.unidade} ${t('deleted')}!`);
        setOpenRemove(false);
        getPlaces(customerId);
      } catch (err) {

        toast.error(`${t('Services.servicesManagement.errorRemoving')}`);
      }
    });

  const edit = async (name: string) => {
    setIsDisabled(true);
    try {
      const token = await AttToken();
      if (token) {
        const response = await UnityService.editUnity(token, unity.id, name);
        if (response) {
          setOpenEditModal(false);
          toast.success(`${hierarchyLabel.unidade} ${t('edited')}!`);
          getPlaces(customerId);
        }
      }
    } catch (err) {
      return console.log(err);
    }
  };

  const { mutate: clone } = queryFn.useMutate('CLONE_UNITY',
    async (unityid: string) => {
      trackEventMatomo('tela de locais', 'click', 'button', 'duplica unidade');
      toast.warn(`${t('places.Copiando_aguarde')}`);
      try {
        const token = await AttToken();
        if (token) {
          const response = await UnityService.duplicateUnity(token, unityid);
          if (response) {
            unidadesList.push(Object.values(response.updateUnidade)[0] as unknown as UnidadeType);
            getPlaces(customerId);
          }
        }
      } catch (err) {
        console.log(AxiosError);
      }
    }
  );

  const nameOf = 'unidade';
  const nameRemove = 'unidade';

  return (
    <>
      {openRemove &&
        <RemoveModal
          mutate={mutate}
          openRemove={openRemove}
          setOpenRemove={setOpenRemove}
          nameRemove={nameRemove}
        />}
      {openEditModal &&
        <EditModal
          isDisabled={isDisabled}
          edit={edit}
          open={openEditModal}
          setOpen={setOpenEditModal}
          componentName={unity.nome}
          nameOf={nameOf}
        />}
      <Stack
        sx={{ paddingLeft: '10px' }}
        width='100%'
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography sx={{ color: '#4AA78A' }} variant='h6' fontWeight={600}>
          {unity.nome}
        </Typography>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
        >
          <Tooltip title={`${t('edit')} ${hierarchyLabel.unidade}`}>
            <IconButton aria-label="edit" color='info'>
              <AiFillTool
                onClick={() => {
                  trackEventMatomo('tela de locais', 'click', 'button', 'abre modal');
                  setOpenEditModal(true);
                }}
                size={25} />
            </IconButton>
          </Tooltip>
          <Tooltip title={`${t('checklists.checklists.clone')} ${hierarchyLabel.unidade}`}>
            <IconButton aria-label="clone" color='success'>
              <AiFillCopy onClick={() => clone(unity.id)} size={25} />
            </IconButton>
          </Tooltip>
          <Tooltip title={`${t('delete')} ${hierarchyLabel.unidade}`}>
            <IconButton aria-label="delete" color='error'>
              <AiFillDelete
                onClick={() => {
                  trackEventMatomo('tela de locais', 'click', 'button', 'remove unidade');
                  setOpenRemove(true);
                }}
                size={25} />
            </IconButton>
          </Tooltip>
          <QrCodeModal unity={unity} />
        </Stack>
      </Stack>
    </>
  );
}
